'use strict';

angular.module('app')

.run(function (Season) {}) // jshint ignore:line

.factory('Season', function (DS) {
    return DS.defineResource({
        name: 'Season',
        endpoint: 'seasons',
        upsert: true
    });
});
